<template>
  <div class="home">
    <Discounts :news-array="discountsArray"></Discounts>
    <InfoAdvantages></InfoAdvantages>
    <GoodsSection
        :title="'Акции'"
        v-if="discountedGoodsArray && discountedGoodsArray.length > 0"
        :goods-array="discountedGoodsArray"
    ></GoodsSection>

    <GoodsSection
      :title="'Хиты продаж'"
      v-if="heatsArray && heatsArray.length > 0"
      :goods-array="heatsArray"
    ></GoodsSection>

<!--    <div style="height: 1200px"></div>-->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import InfoAdvantages from "@/components/landing/InfoAdvantages";
import Discounts from "@/components/landing/Discounts";
import GoodsSection from "@/components/landing/GoodsSection";
import axios from "axios";

export default {
  name: 'HomeView',
  components: {
    GoodsSection,
    Discounts,
    InfoAdvantages,
    HelloWorld
  },
  data(){
    return {
      discountsArray: [],

      heatsArray: [],
      discountedGoodsArray: []
    }
  },
  mounted() {
    this.onLoadNews()
    this.onLoadHeats()
    this.onLoadDiscounts()
  },
  methods: {
    async onLoadNews(){
      axios.get('/api/open/news/last').then(res => {
        if(res.status === 200){
          this.discountsArray = res.data;
        }
      }).catch(e => {
        console.log(e)
      })
    },
    async onLoadHeats(){
      axios.get('/api/open/items/heats').then(res => {
        if(res.status === 200){
          this.heatsArray = res.data
        }
      }).catch(e => {
        console.log(e)
      })
    },
    async onLoadDiscounts(){
      axios.get('/api/open/items/discounted').then(res => {
        if(res.status === 200){
          this.discountedGoodsArray = res.data
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
<style scoped lang="scss">
.home{
  display: flex;
  flex-direction: column;
  padding: 2rem .25rem 2rem .25rem;
  gap: 1rem;
  width: 100%;
  height: 100%;
}
</style>